/* Körpergrößen-Filter (snippets/cb-kg-filter.liquid)
   Eingabe 140–210 cm → abrunden auf 5-cm-Stufe → Filterwert cb_size.koerpergroesse_stufen setzen.
   Gefiltert wird bei Enter oder beim Verlassen des Feldes (Handy: Tastatur schließen).
   Die eingegebene Größe steht als „kg=178“ in der URL und im sessionStorage, damit Feld und
   aktiver Filter („Körpergröße: 178 cm ✕“) beim Blättern und Kombinieren die echte Eingabe zeigen. */
(function () {
  if (window.cbKgLoaded) return;
  window.cbKgLoaded = true;

  var MIN = 140, MAX = 210, STEP = 5, STORE_KEY = 'cbKoerpergroesse';

  function stufeOf(cm) { return String(Math.floor(cm / STEP) * STEP); }

  function storedKg() {
    try { return parseInt(sessionStorage.getItem(STORE_KEY), 10) || null; } catch (e) { return null; }
  }
  function storeKg(cm) {
    try { cm ? sessionStorage.setItem(STORE_KEY, String(cm)) : sessionStorage.removeItem(STORE_KEY); } catch (e) {}
  }

  // Eingegebene Größe passend zu den aktiven Stufen: zuerst aus der URL, sonst aus dem sessionStorage
  function knownKg(activeStufen) {
    var fromUrl = parseInt(new URLSearchParams(window.location.search).get('kg'), 10);
    var candidates = [fromUrl, storedKg()];
    for (var i = 0; i < candidates.length; i++) {
      var cm = candidates[i];
      if (cm >= MIN && cm <= MAX && activeStufen.indexOf(stufeOf(cm)) !== -1) return cm;
    }
    return null;
  }

  class CbKgFilter extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('.cb-kg__input');
      this.msg = this.querySelector('.cb-kg__msg');
      this.kgField = this.querySelector('.cb-kg__kg');
      try { this.counts = JSON.parse(this.dataset.counts || '{}'); } catch (e) { this.counts = {}; }

      var active = this.activeStufen();
      var cm = knownKg(active);
      if (cm) {
        this.input.value = cm;
        this.kgField.value = cm;
        this.kgField.disabled = false;
      } else if (active.length) {
        this.input.value = active[0];
      }
      this.lastApplied = this.input.value;

      // Tippen darf nicht sofort filtern (facets.js hört auf „input“ am Formular)
      this.input.addEventListener('input', (e) => {
        e.stopPropagation();
        this.input.value = this.input.value.replace(/\D/g, '').slice(0, 3);
        this.setMsg('');
      });
      this.input.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        this.apply();
        // Am Handy die Zahlentastatur schließen, damit die Treffer sichtbar werden
        if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) this.input.blur();
      });
      this.input.addEventListener('blur', () => {
        if (this.input.value !== this.lastApplied) this.apply();
      });
    }

    activeStufen() {
      return Array.prototype.map.call(this.querySelectorAll('.cb-kg__stufe'), function (el) { return el.value; });
    }

    setMsg(text) {
      this.msg.textContent = text;
      this.msg.classList.toggle('is-visible', !!text);
    }

    apply() {
      var raw = this.input.value.trim();
      if (raw === this.lastApplied) { this.setMsg(''); return; }  // z. B. Blur und Klick auf OK direkt nacheinander
      if (raw === '') {
        if (this.activeStufen().length) this.submit(null);
        return;
      }
      var cm = /^\d+$/.test(raw) ? parseInt(raw, 10) : NaN;
      if (!(cm >= MIN && cm <= MAX)) {
        this.setMsg('Bitte gib deine Körpergröße in ganzen Zentimetern zwischen ' + MIN + ' und ' + MAX + ' ein, z. B. 178.');
        return;
      }
      var stufe = stufeOf(cm);
      if (!this.counts[stufe] && this.activeStufen().indexOf(stufe) === -1) {
        this.setMsg('Für ' + cm + ' cm finden wir mit deiner aktuellen Auswahl gerade kein passendes Rad. Schau gern in einer unserer Filialen vorbei.');
        return;
      }
      this.submit(cm);
    }

    submit(cm) {
      this.setMsg('');
      this.lastApplied = cm ? String(cm) : '';
      storeKg(cm);
      this.querySelectorAll('.cb-kg__stufe').forEach(function (el) { el.remove(); });
      if (cm) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.className = 'cb-kg__stufe';
        hidden.name = this.dataset.param;
        hidden.value = stufeOf(cm);
        this.appendChild(hidden);
      }
      this.kgField.value = cm || '';
      this.kgField.disabled = !cm;

      var formEl = this.closest('form');
      var facets = this.closest('facet-filters-form');
      if (facets && typeof facets.onSubmitHandler === 'function') {
        facets.onSubmitHandler({ preventDefault: function () {}, target: this.kgField });
      } else if (formEl) {
        formEl.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }
  if (!customElements.get('cb-kg-filter')) customElements.define('cb-kg-filter', CbKgFilter);

  // ⓘ am Titel: Hinweis ein-/ausblenden, ohne die Gruppe auf-/zuzuklappen (wie beim Akku-Filter)
  function toggleHint(e) {
    var info = e.target.closest && e.target.closest('.cb-kg-row .cbf-info');
    if (!info) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    var row = info.closest('.cb-kg-row');
    var open = row.classList.toggle('cbf-hint-open');
    info.setAttribute('aria-expanded', open ? 'true' : 'false');
    var details = row.querySelector('details');
    if (details && !details.open) details.open = true;
  }
  document.addEventListener('click', toggleHint, true);
  document.addEventListener('keydown', toggleHint, true);

  // Aktiver Filter: „Körpergröße: 178 cm“ statt „175–179 cm“; beim Entfernen auch kg= aus der URL nehmen
  function updateChips() {
    document.querySelectorAll('.cb-kg-chip').forEach(function (chip) {
      var href = chip.getAttribute('href') || '';
      var q = href.indexOf('?');
      if (q !== -1) {
        var params = new URLSearchParams(href.slice(q + 1));
        if (params.has('kg')) {
          params.delete('kg');
          var rest = params.toString();
          chip.setAttribute('href', href.slice(0, q) + (rest ? '?' + rest : ''));
        }
      }
      var cm = knownKg([chip.dataset.cbKgStufe]);
      if (!cm) return;
      var icon = chip.querySelector('span');
      chip.textContent = 'Körpergröße: ' + cm + ' cm';
      if (icon) chip.appendChild(icon);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateChips);
  } else {
    updateChips();
  }
  document.addEventListener('facets:updated', updateChips);
})();
